export const tags = (t) => [
    { id: 'pages', label: t('discover.author.tabs.pages') },
    { id: 'categories', label: t('discover.author.tabs.categories') },
    { id: 'entities', label: t('discover.author.tabs.entities') },
];
